import { registerPlugin } from '@capacitor/core'

export const LiveActivity: {
  registerPushTokens(): Promise<{ value: boolean }>

  addListener(
    eventName: 'startTokenReceived',
    listenerFunc: (data: { token: string }) => void
  ): void
} = registerPlugin('LiveActivity')
